

export const countryFlags = {
  
  CN: "🇨🇳", 
  JP: "🇯🇵", 
  KR: "🇰🇷", 
  IN: "🇮🇳", 
  SG: "🇸🇬", 
  TH: "🇹🇭", 
  VN: "🇻🇳", 
  MY: "🇲🇾", 
  ID: "🇮🇩", 
  PH: "🇵🇭", 
  TW: "🇹🇼", 
  HK: "🇭🇰", 
  MO: "🇲🇴", 
  AE: "🇦🇪", 
  SA: "🇸🇦", 
  IL: "🇮🇱", 
  TR: "🇹🇷", 
  RU: "🇷🇺", 
  KZ: "🇰🇿", 
  UZ: "🇺🇿", 
  PK: "🇵🇰", 
  BD: "🇧🇩", 
  LK: "🇱🇰", 
  NP: "🇳🇵", 
  MM: "🇲🇲", 
  KH: "🇰🇭", 
  LA: "🇱🇦", 
  MN: "🇲🇳", 
  BT: "🇧🇹", 
  MV: "🇲🇻", 
  BN: "🇧🇳", 
  TL: "🇹🇱", 
  AF: "🇦🇫", 
  IQ: "🇮🇶", 
  IR: "🇮🇷", 
  SY: "🇸🇾", 
  LB: "🇱🇧", 
  JO: "🇯🇴", 
  PS: "🇵🇸", 
  KW: "🇰🇼", 
  QA: "🇶🇦", 
  BH: "🇧🇭", 
  OM: "🇴🇲", 
  YE: "🇾🇪", 
  AM: "🇦🇲", 
  AZ: "🇦🇿", 
  GE: "🇬🇪", 
  CY: "🇨🇾", 

  GB: "🇬🇧", 
  FR: "🇫🇷", 
  DE: "🇩🇪", 
  IT: "🇮🇹", 
  ES: "🇪🇸", 
  PT: "🇵🇹", 
  NL: "🇳🇱", 
  BE: "🇧🇪", 
  CH: "🇨🇭", 
  AT: "🇦🇹", 
  SE: "🇸🇪", 
  NO: "🇳🇴", 
  DK: "🇩🇰", 
  FI: "🇫🇮", 
  IS: "🇮🇸", 
  IE: "🇮🇪", 
  LU: "🇱🇺", 
  MC: "🇲🇨", 
  AD: "🇦🇩", 
  SM: "🇸🇲", 
  VA: "🇻🇦", 
  MT: "🇲🇹", 
  PL: "🇵🇱", 
  CZ: "🇨🇿", 
  SK: "🇸🇰", 
  HU: "🇭🇺", 
  SI: "🇸🇮", 
  HR: "🇭🇷", 
  BA: "🇧🇦", 
  RS: "🇷🇸", 
  ME: "🇲🇪", 
  MK: "🇲🇰", 
  AL: "🇦🇱", 
  BG: "🇧🇬", 
  RO: "🇷🇴", 
  MD: "🇲🇩", 
  UA: "🇺🇦", 
  BY: "🇧🇾", 
  LT: "🇱🇹", 
  LV: "🇱🇻", 
  EE: "🇪🇪", 
  GR: "🇬🇷", 

  US: "🇺🇸", 
  CA: "🇨🇦", 
  MX: "🇲🇽", 
  GT: "🇬🇹", 
  BZ: "🇧🇿", 
  SV: "🇸🇻", 
  HN: "🇭🇳", 
  NI: "🇳🇮", 
  CR: "🇨🇷", 
  PA: "🇵🇦", 

  BR: "🇧🇷", 
  AR: "🇦🇷", 
  CL: "🇨🇱", 
  PE: "🇵🇪", 
  CO: "🇨🇴", 
  VE: "🇻🇪", 
  EC: "🇪🇨", 
  BO: "🇧🇴", 
  PY: "🇵🇾", 
  UY: "🇺🇾", 
  GY: "🇬🇾", 
  SR: "🇸🇷", 
  GF: "🇬🇫", 

  ZA: "🇿🇦", 
  EG: "🇪🇬", 
  MA: "🇲🇦", 
  DZ: "🇩🇿", 
  TN: "🇹🇳", 
  LY: "🇱🇾", 
  SD: "🇸🇩", 
  SS: "🇸🇸", 
  ET: "🇪🇹", 
  ER: "🇪🇷", 
  DJ: "🇩🇯", 
  SO: "🇸🇴", 
  KE: "🇰🇪", 
  UG: "🇺🇬", 
  TZ: "🇹🇿", 
  RW: "🇷🇼", 
  BI: "🇧🇮", 
  MW: "🇲🇼", 
  ZM: "🇿🇲", 
  ZW: "🇿🇼", 
  BW: "🇧🇼", 
  NA: "🇳🇦", 
  SZ: "🇸🇿", 
  LS: "🇱🇸", 
  MZ: "🇲🇿", 
  MG: "🇲🇬", 
  MU: "🇲🇺", 
  SC: "🇸🇨", 
  KM: "🇰🇲", 
  AO: "🇦🇴", 
  CD: "🇨🇩", 
  CG: "🇨🇬", 
  CF: "🇨🇫", 
  TD: "🇹🇩", 
  CM: "🇨🇲", 
  GQ: "🇬🇶", 
  GA: "🇬🇦", 
  ST: "🇸🇹", 
  NG: "🇳🇬", 
  NE: "🇳🇪", 
  BF: "🇧🇫", 
  ML: "🇲🇱", 
  SN: "🇸🇳", 
  MR: "🇲🇷", 
  GM: "🇬🇲", 
  GW: "🇬🇼", 
  GN: "🇬🇳", 
  SL: "🇸🇱", 
  LR: "🇱🇷", 
  CI: "🇨🇮", 
  GH: "🇬🇭", 
  TG: "🇹🇬", 
  BJ: "🇧🇯", 

  AU: "🇦🇺", 
  NZ: "🇳🇿", 
  FJ: "🇫🇯", 
  PG: "🇵🇬", 
  SB: "🇸🇧", 
  VU: "🇻🇺", 
  NC: "🇳🇨", 
  PF: "🇵🇫", 
  WS: "🇼🇸", 
  TO: "🇹🇴", 
  TV: "🇹🇻", 
  KI: "🇰🇮", 
  NR: "🇳🇷", 
  FM: "🇫🇲", 
  MH: "🇲🇭", 
  PW: "🇵🇼", 
  CK: "🇨🇰", 
  NU: "🇳🇺", 

  CU: "🇨🇺", 
  JM: "🇯🇲", 
  HT: "🇭🇹", 
  DO: "🇩🇴", 
  PR: "🇵🇷", 
  TT: "🇹🇹", 
  BB: "🇧🇧", 
  GD: "🇬🇩", 
  VC: "🇻🇨", 
  LC: "🇱🇨", 
  DM: "🇩🇲", 
  AG: "🇦🇬", 
  KN: "🇰🇳", 
  BS: "🇧🇸", 
  BZ: "🇧🇿", 

  GL: "🇬🇱", 
  FO: "🇫🇴", 
  AX: "🇦🇽", 
  SJ: "🇸🇯", 
  BV: "🇧🇻", 
  HM: "🇭🇲", 
  GS: "🇬🇸", 
  TF: "🇹🇫", 
  AQ: "🇦🇶", 
  IO: "🇮🇴", 
  CC: "🇨🇨", 
  CX: "🇨🇽", 
  NF: "🇳🇫", 
  PN: "🇵🇳", 
  SH: "🇸🇭", 
  FK: "🇫🇰", 
  WF: "🇼🇫", 
  EH: "🇪🇭", 
  YT: "🇾🇹", 
  RE: "🇷🇪", 
  MQ: "🇲🇶", 
  GP: "🇬🇵", 
  BL: "🇧🇱", 
  MF: "🇲🇫", 
  PM: "🇵🇲", 
  VI: "🇻🇮", 
  VG: "🇻🇬", 
  AS: "🇦🇸", 
  GU: "🇬🇺", 
  MP: "🇲🇵", 
  UM: "🇺🇲", 
  TC: "🇹🇨", 
  KY: "🇰🇾", 
  BM: "🇧🇲", 
  MS: "🇲🇸", 
  AI: "🇦🇮", 
  JE: "🇯🇪", 
  GG: "🇬🇬", 
  IM: "🇮🇲", 
  GI: "🇬🇮", 
};

export const getCountryFlag = (countryCode) => {
  if (!countryCode || typeof countryCode !== "string") {
    return "🌍"; 
  }

  const code = countryCode.toUpperCase();
  return countryFlags[code] || "🌍"; 
};

export const getSupportedCountryCodes = () => {
  return Object.keys(countryFlags);
};

export const isCountryCodeSupported = (countryCode) => {
  if (!countryCode || typeof countryCode !== "string") {
    return false;
  }
  return countryFlags.hasOwnProperty(countryCode.toUpperCase());
};

export const countryUtils = {
  getCountryFlag,
  getSupportedCountryCodes,
  isCountryCodeSupported,
  countryFlags,
};
